import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import styled from 'styled-components';

import {CodeResponseBody} from '@dms/api/core';

import {CodelistItem} from './CodelistItem';

interface SortableCodelistItemProps {
  code: CodeResponseBody;
  codelistId: string;
}

const SortableItemWrapper = styled.div<{
  $transform: string | undefined;
  $transition: string | undefined;
  $isDragging: boolean;
}>`
  transform: ${({$transform}) => $transform};
  transition: ${({$transition}) => $transition};
  opacity: ${({$isDragging}) => ($isDragging ? 0 : 1)};
`;

export function SortableCodelistItem(props: SortableCodelistItemProps) {
  const {attributes, listeners, setNodeRef, transform, transition, isDragging} = useSortable({
    id: props.code.codeId,
  });
  const transformString = transform ? CSS.Transform.toString(transform) : undefined;

  const handleProps = {
    ...attributes,
    ...listeners,
  };

  return (
    <SortableItemWrapper
      ref={setNodeRef}
      $transform={transformString}
      $transition={transition}
      $isDragging={isDragging}
    >
      <CodelistItem code={props.code} codelistId={props.codelistId} handleProps={handleProps} />
    </SortableItemWrapper>
  );
}
